import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const AssociatedPersonnel = React.lazy(() => import('.'));

export const associatedPersonnelRoutes = [
  new Route({
    path: 'associated-personnel',
    element: AssociatedPersonnel,
    children: [],
  }),
];
